import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Dashboard } from "./Dashboard";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "WORKTIME",
    applicationRights: Rights,
    title: 'Arbeidstid',
    text: 'Arbeidstid',
    icon: 'timer',
    url: "/worktime-registry",
    mobileThreshold: 1024,
    sequenceNo: 3000,
    routes: Routes,
    dashboard: Dashboard
})
